"use client";

type WindowWithDataLayer = Window & {
  dataLayer: { [key: string]: unknown }[];
};

export declare const window: WindowWithDataLayer;

type DataLayerObject = {
  event: string;
  [key: string]: unknown;
};

const send = (object: DataLayerObject) => window.dataLayer.push(object);
const clearECommerce = () => window.dataLayer.push({ ecommerce: null });

export const GTM = {
  addToCart(price: number, currency: string, item_id: number) {
    clearECommerce();
    send({
      event: "add_to_cart",
      ecommerce: {
        currency: currency,
        value: price,
        items: [
          {
            item_id,
            price,
            quantity: 1,
          },
        ],
      },
    });
  },
  purchase(value: number, currency: string, transaction_id: number, items: []) {
    clearECommerce();
    send({
      event: "purchase",
      currency,
      transaction_id,
      value,
      items,
    });
  },
  newsletterSignup() {
    send({ event: "newsletter_form_submit" });
  },
  signUp() {
    send({ event: "sign_up" });
  },
  unsupportedAddress() {
    send({
      event: "Business process exception",
      variant: "Address not supported",
    });
  },
};
